module.exports = __webpack_public_path__ + "img/pw.232251df.svg";